import { USER_INFO_LOADING, LOAD_USER_INFO_SUCCESS, LOAD_USER_INFO_FAIL } from "./actions";
import { IUserState } from ".";

export const userInfoLoading = () => ({ type: USER_INFO_LOADING })
export const userInfoSuccess = (userInfo: IUserState) => ({ type: LOAD_USER_INFO_SUCCESS, payload: userInfo })
export const userInfoFail = (reason) => ({ type: LOAD_USER_INFO_FAIL })



// WEBPACK FOOTER //
// ./src/store/modules/user/actionCreators.ts